import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jiraAutomation: {
		id: 'spa-apps-sidebar-servicedesk.common.automation.jira-automation',
		defaultMessage: 'Automation',
		description: 'Title of item in navigation that redirects to the Jira automation page',
	},
	legacyAutomation: {
		id: 'spa-apps-sidebar-servicedesk.common.automation.legacy-automation',
		defaultMessage: 'Legacy automation',
		description:
			'Title of item in navigation that redirects to the legacy Jira Service Management only automation page',
	},
	automation: {
		id: 'spa-apps-sidebar-servicedesk.common.automation.automation',
		defaultMessage: 'Automation',
		description: 'Settings navigation menu link for a service project',
	},
	newLozenge: {
		id: 'spa-apps-sidebar-servicedesk.common.automation.new-lozenge',
		defaultMessage: 'New',
		description:
			'Small lozenge that appears to the right of the nav item, indicating a new feature.',
	},
});
